// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orderProcessCol .el-tabs__item.is-active {\n  text-decoration: underline;\n}\n.orderProcessCol .el-tabs__item {\n  padding: 0 10px;\n}\n.orderProcessCol .el-input__inner {\n  border: 0;\n}", ""]);
// Exports
module.exports = exports;
